import * as XLSX from "xlsx"; // Import the XLSX library
import { serviceResponseTransformation } from "./download-utils/transformDataToExport";
import { generateFilename } from "./download-utils/generateFilenameToExport";
import { saveFileWithPicker } from "../../utils/fileManagerFunctions";


export const exportToCSV = (serviceResponses, filename) => {
  let csvData = [];

  // Ensure serviceResponses is an array
  if (!Array.isArray(serviceResponses)) {
    serviceResponses = [serviceResponses]; // Wrap in array if it's not
  }

  const addRow = (row) => {
    csvData.push(row);
  };

  const formatValue = (value) => {
    if (typeof value === "object" && value !== null) {
      // Handle arrays
      if (Array.isArray(value)) {
        return value.map(formatValue).join(", ");
      }

      // Handle objects by formatting key-value pairs
      return Object.entries(value)
        .map(([key, val]) => `${key}: ${formatValue(val)}`)
        .join(" | ");
    }

    return value; // Return non-object values as-is
  };

  const handleFlattenedObject = (flattenedObject) => {
    const headers = ["Parameter", "Value"];
    addRow(headers); // Add headers as the first row

    Object.keys(flattenedObject).forEach((key) => {
      addRow([key, formatValue(flattenedObject[key])]);
    });
  };

  serviceResponses.forEach((serviceResponse, index) => {
    if (!serviceResponse) {
      return;
    }

    const title = `${filename} - ${index + 1}`;

    // If service response is a string
    if (typeof serviceResponse === "string") {
      addRow(["User Story", serviceResponse]);

      return;
    }

    if (typeof serviceResponse === "object" && !Array.isArray(serviceResponse)) {
      // Check if the object is a flattened object
      handleFlattenedObject(serviceResponse);
      return;
    }

    const { headers, values } = serviceResponseTransformation(serviceResponse, filename, "csv") || {};

    if (!headers || !values || values.length === 0) {
      return;
    }

    addRow(headers); // Add headers
    values.forEach((valueRow) => {
      addRow(valueRow); // Add each row of values
    });
  });

  // Create a new workbook from csvData array
  const ws = XLSX.utils.aoa_to_sheet(csvData); // Convert the array of arrays to a worksheet
  const wb = XLSX.utils.book_new(); // Create a new workbook
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); // Append the sheet to the workbook

  // Generate filename and export
  // const extendedFileName = generateFilename(filename, "csv");
  const wbout = XLSX.write(wb, {
    bookType: "csv", // or "xlsx", depending on your desired format
    type: "array"
  });
  
  const blob = new Blob([wbout], {
    type: "text/csv;charset=utf-8;" // for CSV; for XLSX use appropriate MIME type
  });
  
  const extendedFileName = generateFilename(filename, "csv"); // or "xlsx"
  saveFileWithPicker(blob, extendedFileName);
};
